import React from 'react';
import PropTypes from 'prop-types';

import {
  InputLabel,
} from '@material-ui/core';

import useStyles from './commonStyles';

const CustomInputLabel = props => {
  const classes = useStyles();
  const { id, children } = props;

  return (
    <InputLabel id={id} shrink={true} classes={{
      root: classes.textFieldLabel
    }}>
      {children}
    </InputLabel>
  )
}

CustomInputLabel.propTypes = {
  id: PropTypes.string,
  children: PropTypes.any
};

export default CustomInputLabel;
